<template>                    
    <form-helper> 
        <div slot="form-header">
            
            <h2>Warengruppen</h2>                                                
            
        </div>
        <div slot="form-fields">
            <v-layout row>
                <v-flex xs4>
                    <v-card class="ma-3 pa-2">
                        <v-card-title>
                            <h4 class="grey--text"> File Upload </h4>
                        </v-card-title>
                        <v-card-text class="grey--text">
                            {{ fileSrc.name }}
                        </v-card-text>                                          

                        <v-card-actions>
                            <v-flex xs-2 offset-xs5>
                                <v-btn flat class="grey darken-3 file-btn">                             
                                    <v-icon x-large class="grey--text">backup</v-icon>                             
                                    <input 
                                        name="import_file"
                                        type="file" 
                                        v-validate="'required|ext:csv'"
                                        v-on:change="onFileChange"/>
                                </v-btn>
                                <small class="small red--text" v-show="errors.has('import_file')">{{ errors.first('import_file') }}</small> 
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                </v-flex>
                <v-flex xs6>
                    <v-container grid-list-xs>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card>
                                    <v-card-text>
                                        
                                        
                                    </v-card-text>
                                                                                                                                                   
                                </v-card>
                            </v-flex>                                                                   
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
        </div>
        
        <div slot="form-commands" >

            <v-btn icon v-on:click="submitted">
                <v-icon x-large class="green--text">done</v-icon>
            </v-btn>                        


            <router-link to="/dashboard" exact>
                <v-btn icon>
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>
            </router-link>

        </div>
        
        
    </form-helper>



</template>
<script>
import formHelper from '../../formHelper.vue'

export default {
    inject: ['$validator'],
    components: {
        'form-helper': formHelper,
        
    },
    data() {
        return {            
            fileSrc:'',  
            fileData:{}
        };
    },
    
    computed: {
                              
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 
    },
    methods: {
        submitted: function() {
                        
            this.$store.commit('setMessagebar', false)
            this.$validator.validateAll().then((result) =>{
               if(!result) {
                   this.$store.commit('setMessagebar',true)
                   return
               }
               this.$emit('submitted', this.fileData)
            })
        },
        
        
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }   
            this.fileSrc = e.target.files[0]
            this.fileData = new FormData();
            this.fileData.append("import_file", this.fileSrc)
            
        },
       
        
                     
    }
}
    
</script>

<style>
    
    .file-btn {
    cursor: pointer;
    position: relative;
    overflow: hidden;
   
  }
    .file-btn input[type=file] {
    
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    cursor: inherit;
    display: block;
    
  }
    
</style>


// WEBPACK FOOTER //
// importWarengruppen.vue?dc4b0484